import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage

import authReducer from "@/components/features/slices/authSlice";
import userReducer from "@/components/features/slices/userSlice";
import analyticsReducer from "@/components/features/slices/analyticsSlice";
import flightReducer from "@/components/features/slices/flightSlice";
import hotelReducer from "@/components/features/slices/hotelSlice";
import transactionReducer from "@/components/features/slices/transactionSlice";
import refundReducer from "@/components/features/slices/refundSlice";
import walletReducer from "@/components/features/slices/walletSlice";
import supportReducer from "@/components/features/slices/supportSlice";


const authPersistConfig = {
    key: "auth",
    storage,
      whitelist: ["token","user"],
};

const userPersistConfig = {
    key: "user",
    storage,
      whitelist: ["users"],
};

const appReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    user: persistReducer(userPersistConfig, userReducer),
    analytics: analyticsReducer,
    flight: flightReducer,
    hotel: hotelReducer,
    transaction: transactionReducer,
    refund: refundReducer,
    wallet: walletReducer,
    support: supportReducer
});

const rootReducer = (state, action) => {
    if (action.type == "auth/logout") {
        state = undefined;
    }
    return appReducer(state, action)
}

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);
